<mat-card class="mat-elevation-z0 filter-widget-container" (click)='stopPropagation($event)' [style.border]="'unset'" [style.box-shadow]="'unset'">
    <form (ngSubmit)="submit()">
        <mat-card-content>
            <div fxLayout="row">
                <mat-form-field appearance="outline">
                    <mat-label>{{ translations.WIDGET.PROPERTY }}</mat-label>
                    <mat-select [placeholder]="translations.WIDGET.PROPERTY" [required]='true'
                        (selectionChange)='onChangeFacet($event)' [(ngModel)]="filter.property" name='property'>
                        <mat-optgroup *ngFor="let group of groupedFacets.groups" [label]="group.name">
                            <mat-option *ngFor="let facet of group.facets" [value]="facet.property">
                                {{facet.label}}
                            </mat-option>
                        </mat-optgroup>
                        <mat-option [value]="facet.property" *ngFor='let facet of groupedFacets.facets'>
                            {{facet.label}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div fxLayout="row">
                <mat-form-field appearance="outline">
                    <mat-label>{{ translations.WIDGET.OPERATOR }}</mat-label>
                    <mat-select [placeholder]="translations.WIDGET.OPERATOR" [(ngModel)]="filter.operator"
                        name='operator' [disabled]='selectedFacet?.operators.length > 1 ? false: true'>
                        <mat-option [value]="operator" *ngFor='let operator of selectedFacet?.operators'>
                            {{ translations.OPERATORS[operator] }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div [hidden]="filter.operator === 'HAS' || filter.operator === 'HAS_NOT'">
                <div fxLayout="row" [ngSwitch]="selectedFacet?.widget.type">
                    <mat-form-field *ngSwitchCase="'text'" appearance="outline">
                        <mat-label>{{ translations.WIDGET.VALUE }}</mat-label>
                        <input matInput [placeholder]="translations.WIDGET.VALUE" [(ngModel)]="filter.value" name='value'>
                    </mat-form-field>

                    <mat-form-field *ngSwitchCase="'date'" appearance="outline">
                        <input matInput [matDatepicker]="picker" [(ngModel)]="filter.value" name='value'>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field *ngSwitchCase="'select'" appearance="outline">
                        <mat-select [(ngModel)]="filter.value" name='value' [multiple]='facetOptions.multiple'>
                            <mat-option [value]="choice.value" *ngFor='let choice of facetOptions.choices | async'>
                                {{ choice.displayValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!--SAC requires hack to work-->
                    <ng-container #autocompleteContainer></ng-container>

                    <ng-template #autocompleteTemplate>
                        <syn-multi-picker [(ngModel)]="filter.value" [name]='selectedFacet.property'
                            [content]="facetOptions.choices" [contentLoader]="facetOptions.loader"
                            [chipTemplate]="autocompleteTemplate" [itemTemplate]="autocompleteTemplate">
                            <ng-template #autocompleteTemplate let-displayValue="content.displayValue">
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <span>{{ displayValue }}</span>
                                </div>
                            </ng-template>
                        </syn-multi-picker>
                    </ng-template>

                    <mat-form-field *ngSwitchCase="'quick'" appearance="outline">
                        <input matInput [(ngModel)]="filter.value" name='value' [disabled]='true'>
                    </mat-form-field>

                </div>
            </div>
        </mat-card-content>

        <mat-card-actions fxLayout="row" fxLayoutAlign="center" fxLayoutGap="15px">
            <button mat-flat-button type='button' mat-button
                (click)='close()'>{{ translations.ACTIONS.CANCEL }}</button>
            <button mat-raised-button color="accent" [disabled]="!filter.value && filter.operator !== 'HAS' && filter.operator !== 'HAS_NOT'" mat-button
                type="submit">{{ translations.ACTIONS.SAVE }}</button>
        </mat-card-actions>
    </form>
</mat-card>
